import React, { useCallback, FC, ReactNode } from 'react';
import { Field } from 'formik';
import SelectableSearchDropdown from '@minecraft.selectable-search-dropdown';
import { withErrorMessage, setFieldValueAndTouched } from '@minecraft.utils';

/** Help Component */
type DropdownWithErrorMessageProps = {
  form: Record<string, any>;
  field: Record<string, any>;
  hideSelectAll: boolean;
  saveAsOption?: boolean;
  children: any;
  onChange: (options?: any) => any; // don't use this method because setFieldValueAndTouched calls instead of it
  withOnChange: (options?: any) => any;
  onOptionsFetch?: () => void;
  lazyLoad?: boolean;
  isLoading?: boolean;
  toggleInputLabel?: string;
};

const FormikSelectableSearchDropdownComponent: FC<DropdownWithErrorMessageProps> = ({
  form,
  field,
  onChange,
  withOnChange,
  hideSelectAll,
  children,
  ...restProps
}) => {
  const handleOnChange = useCallback(
    (options): void => {
      setFieldValueAndTouched(field.name, options, form);
      if (withOnChange) {
        withOnChange(options);
      }
    },
    [withOnChange, form, field.name]
  );

  return (
    <SelectableSearchDropdown
      name={field.name}
      values={field.value}
      hideSelectAll={hideSelectAll}
      onChange={handleOnChange}
      {...restProps}
    >
      {children}
    </SelectableSearchDropdown>
  );
};

/** Main Component */
type Props = {
  className?: string;
  name: string;
  initialOptions?: any[];
  resetValue?: any[];
  maxHeight?: string;
  children?: ReactNode;
  noCustomError?: boolean;
  hideSelectAll?: boolean;
  saveAsOption?: boolean;
  fullWidth?: boolean;
  lazyLoad?: boolean;
  isLoading?: boolean;
  onOptionsFetch?: () => void;
  withOnChange?: () => void;
};

const FormikSelectableSearchDropdown = (props: Props): JSX.Element => (
  <Field name={props.name} {...props}>
    {(fieldProps): JSX.Element =>
      withErrorMessage(FormikSelectableSearchDropdownComponent)({ ...props, ...fieldProps })
    }
  </Field>
);
FormikSelectableSearchDropdown.Option = SelectableSearchDropdown.Option;
FormikSelectableSearchDropdown.Section = SelectableSearchDropdown.Section;
export default FormikSelectableSearchDropdown;
